import { useMutation } from '@apollo/client/react';
import { ToggleButton, MuiToggleButtonGroup } from 'components/ui';
import { useError } from 'contexts/error';
import { useThemeMode } from 'contexts/theme';
import { FormattedMessage } from 'react-intl';
import EditMutation from 'mutations/user/edit';

const DisplayModeButton = () => {
  const setError = useError();
  const { mode, setMode } = useThemeMode();

  const [editMutation, { loading }] = useMutation(EditMutation, {
    onError: () => {
      setError('error.user.profile.edit');
    },
  });

  const handleChange = async (_event, nextMode) => {
    if (nextMode === null || nextMode === mode) {
      return;
    }
    try {
      await editMutation({ variables: { darkMode: nextMode === 'dark' } });
      setMode(nextMode);
    } catch {
      // error already handled by onError
    }
  };

  return (
    <MuiToggleButtonGroup
      exclusive
      size="small"
      value={mode}
      onChange={handleChange}
      disabled={loading}
    >
      <ToggleButton value="light">
        <FormattedMessage id="user.profile.display_mode.light" />
      </ToggleButton>
      <ToggleButton value="dark">
        <FormattedMessage id="user.profile.display_mode.dark" />
      </ToggleButton>
    </MuiToggleButtonGroup>
  );
};

export default DisplayModeButton;
